import { stringify } from "qs";
export function createShopifyCartPermalink({ shopifyHostedDomain, variants, cartAttributes = {}, discount, }) {
    return `https://${shopifyHostedDomain}/cart/${
    // adding variants
    variants.map(({ variantId, quantity }) => `${variantId}:${quantity}`).join(",")}${stringify(Object.assign(Object.assign({}, Object.entries(cartAttributes).reduce((accum, [key, value]) => {
        accum[`attributes[${key}]`] = value;
        return accum;
    }, {})), (!discount ? {} : { discount })), {
        addQueryPrefix: true,
    })}`;
}
// there's an odd way to modify the cart in Shopify with this "GET" request
export async function addDiscountToCheckout({ shopifyHostedDomain, cartAttributes = {}, discount, }) {
    await fetch(`https://${shopifyHostedDomain}/checkout${stringify(Object.assign(Object.assign({}, Object.entries(cartAttributes).reduce((accum, [key, value]) => {
        accum[`attributes[${key}]`] = value;
        return accum;
    }, {})), (!discount ? {} : { discount })), {
        addQueryPrefix: true,
    })}`, {
        mode: "no-cors",
    });
}
